<template>
  <div class="yhxy">
    <div class="docs-header">用户协议</div>
    <div class="container">
      <div class="content">利用本小程序服务即视为同意以下用户协议：</div>
      <div class="title">一、关于本用户协议的说明</div>
      <div class="content">本用户协议双方为北京童心弈智教育科技有限公司（下称“弈小象”）与用户，本用户协议具有符合中国相关法律法规规定的合同效力。 本用户协议内容包括协议正文及所有弈小象已经发布的或将来可能发布的各类规则、说明或其他文件。所有上述文件视为本协议不可分割的一部分，与本协议正文具有同等法律效力。 用户在使用弈小象提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。弈小象有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，弈小象将在小程序/官网上刊载公告，通知予用户。如用户不同意相关变更，必须立即停止使用“服务”，否则视为用户同意相关变更。经修订的协议一经在弈小象小程序/官网公布后，立即自动生效。各类规则会在发布后生效，亦成为本协议的一部分。登录或继续使用“服务”将表示用户接受经修订的协议。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。 用户确认本用户协议后，并点击“我已阅读并同意《弈小象用户协议》”后，本用户协议即在用户和弈小象之间产生法律效力。请用户务必在注册之前认真阅读全部用户协议内容，如有任何疑问，可向弈小象客服咨询。 请注意：</div>
      <div class="content">（1）无论用户事实上是否在注册之前认真阅读了本用户协议，只要用户点击协议正本下方的“我已阅读并同意《弈小象用户协议》”按钮并按照弈小象注册程序成功注册为正式用户（下称“注册用户”），用户的行为即表示其同意并签署了本用户协议；
        <div class="content">（2）本协议不涉及用户与弈小象其它用户之间因网络服务而产生的法律关系及法律纠纷；</div>
        <div class="content">（3）弈小象建议用户按照网站的要求实名进行注册，并填写真实有效的联系方式以及地址等信息，以便弈小象更好的为用户提供服务。</div>
      </div>
      <div class="title">二、服务内容</div>
      <div class="content">弈小象为注册已付费用户提供网络培训服务，目前主要为中国象棋培训服务。</div>
      <div class="title">三、服务费用</div>
      <div class="content"><div class="content">1.注册用户可以根据自己的需求选择适合自己的服务内容，每种服务内容均有不同费用标准，每种费用标准包含不同的服务内容。弈小象有权对服务费用及所提供内容作出调整，并于弈小象小程序/官网上以公示的形式生效。服务内容的费用标准及所包含的课程内容与服务项目以实际购买时小程序/官网所示内容为准。
      </div><div class="content">2.所购买的服务内容将于注册用户付清全额费用后开通使用</div>
        <div class="content">3.注册用户所支付的费用仅包含所购买的服务内容，而不包含网络信息费、电话费等。</div></div>
      <div class="title">四、服务使用规则</div>
      <div class="content">1.注册用户购买服务内容成功后，即获得相应的服务，具体规则以弈小象小程序/官网公示的内容为准。</div>
      <div class="content">2.因注册用户原因导致服务取消或变更调整的，具体规则见相应的课程或服务协议。由于弈小象的原因，导致服务无法正常进行，弈小象有义务进行相应的补偿。</div>
      <div class="title">五、用户义务与责任</div>
      <div class="content">1.所有用户不得从事以下行为：
        <div class="content"> （1）向其他用户或其他第三方转让、出借、许可使用、出售全部或部分本服务；</div>
        <div class="content"> （2）侵害弈小象的企业声誉、信用、商标权、著作权等各项合法权利；</div>
        <div class="content"> （3）妨碍弈小象提供服务的行为；</div>
        <div class="content"> （4）利用弈小象服务进行营利及投机行为；</div>
        <div class="content"> （5）犯罪行为及与犯罪有关的行为；</div>
        <div class="content"> （6）使用不恰当语言或行为导致本站老师不愉快的行为；</div>
        <div class="content"> （7）用户本人或通过代理人通过任何方式与老师个人的联络行为；</div>
        <div class="content"> （8）用任何方式打探或窃取弈小象商业机密的行为；</div>
        <div class="content"> （9）违反公序良俗的行为；</div>
        <div class="content"> （10）其它弈小象判断为不适当的行为。</div>
      </div>
      <div class="content">2.所有用户承诺：
        <div class="content"> （1）遵守所有关于使用网络服务的法律法规规定、网络协议、程序和惯例；不得利用弈小象网络教育平台制作、复制、查阅和传播下列信息：
          <div class="content-1">  ①任何不符合国家法律、法规规定的资料、信息；</div>
          <div class="content-1">  ②不利于国家团结和社会安定的资料；</div>
          <div class="content-1">  ③任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；</div>
          <div class="content-1">  ④任何教唆他人进行违法犯罪行为的资料；</div>
          <div class="content-1">  ⑤任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；</div>
          <div class="content-1">  ⑥损害弈小象声誉或商业利益的信息。</div>
        </div>
        <div class="content"> （2）未经允许，不得对弈小象网络教育平台中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</div>
        <div class="content"> （3）不得故意制作、传播计算机病毒等破坏性程序。</div>
        <div class="content"> 如果用户的行为违背上述1、2两款规定，弈小象可以做出独立判断并有权中止甚至立即取消用户资格且不退还剩余课程费用。用户应对自己在弈小象上的违法行为承担全部法律责任。</div>
      </div>
      <div class="content">3.基于网络服务的特殊性，用户同意：
        <div class="content"> （1）自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；</div>
        <div class="content"> （2）自行负担个人上网所产生的与此服务有关的网络信息费及电话费等；</div>
        <div class="content"> （3）在注册时按照注册提示提供准确用户名和密码以及所需的个人真实资料；</div>
        <div class="content"> （4）在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为弈小象提供所有服务的有效身份依据。</div>
      </div>
      <div class="content">4.用户的账户密码和安全性：
        <div class="content"> （1）用户一旦注册成功，成为弈小象的正式用户后，应当对自己的用户名（亦称帐号）、密码的安全性负全部责任。用户的密码只能由用户自己掌握。用户可以通过弈小象网站随时更改密码。</div>
        <div class="content"> （2）由于本站非实名验证会员制对于用户因帐号或密码泄露造成的各种损失，弈小象不承担任何责任。用户应对以其用户名进行的所有活动和事件负责。用户发现任何非法使用其用户帐号或存在安全漏洞的情况，应立即通知弈小象。用户须自行负责对用户名和密码保密，且须对该用户名和密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。用户不可撤销的同意： (a)如发现任何人未经授权使用您的用户名和密码，或发生违反保密规定的任何其他情况，您会立即通知弈小象，并授权弈小象将该信息同步给有权部门；及 (b)确保您在每个上网时段结束时，以正确步骤离开网站/服务。弈小象不能也不会对因您未能遵守本款规定而发生的任何损失负责。您理解弈小象对您的请求采取行动需要合理时间，弈小象对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</div>
      </div>
      <div class="content">5.禁止劝诱：
        <div class="content"> 用户明确了解并同意，用户不得唆使、劝诱弈小象（及关系企业）的员工、老师、顾问与弈小象终止或解除服务关系，或由用户自己介绍他人予以雇佣（无论正式、兼职、约聘）的任何职务。如有违反，用户应承担弈小象为填补该职位空缺所支出的合理费用，并赔偿弈小象因此而遭受的一切实际损失及惩罚性违约金（以该员工离职前年薪的三倍计算）。</div>
      </div>
      <div class="title">六、弈小象的权利和义务</div>
      <div class="content">1.弈小象有义务在现有技术上维护小程序/官网的正常运行，并努力提升和改进技术，使用户网络教学活动得以顺利进行；</div>
      <div class="content">2.对用户在注册使用弈小象中所遇到的与注册或交易有关的问题及反映的情况，弈小象应及时作出回复；</div>
      <div class="content">3.对于用户在弈小象上的不当行为或其它任何弈小象认为应当终止服务的情况，弈小象有权随时作出删除相关信息、终止服务提供等处理，而无须征得用户的同意。</div>
      <div class="content">4.弈小象应本着诚实信用的原则向用户提供服务，不得随意中断或停止提供该项服务。但由于不可抗力或其他非弈小象的原因使小程序/官网系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录或服务中断或停止等，弈小象不承担任何责任。但是弈小象会尽可能合理地协助处理善后事宜，并努力使用户免受经济损失。</div>
      <div class="content">5.弈小象网站内以任何形式表现的作品（包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等）的著作权，由作品的著作权人和北京童心弈智教育科技有限公司及其关联公司共同享有，用户未经许可，不得擅自对弈小象的包括教材、电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯弈小象知识产权的个人和组织，北京童心弈智教育科技有限公司及其关联公司和作品的著作权人将依法追究其民事或刑事责任。</div>
      <div class="content">6.弈小象享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。</div>
      <div class="content">7.许可使用权。弈小象对用户在网上发表的供学习交流的作品，享有独家的出版、发行和复制的权利。用户以此授予弈小象及其关联公司独家的、全球通用的、永久的、免费的许可使用权利 (并有权在多个层面对该权利进行再授权)，使弈小象及其关联公司有权(全部或部份地) 使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部资料数据（包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内。</div>
      <div class="content">8.弈小象将根据互联网的发展和法律、法规的变化，在认为必要时可以单方面修改用户协议。本用户协议一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，则视为接受用户协议的变动。当发生争议时，应以最新用户协议的内容为准。</div>
      <div class="content">弈小象有权根据实际情况，调整网络课程的任课教师，该教师如与宣传材料不符以实际任课教师为准。弈小象将最大限度的保护用户的上课质量。</div>
      <div class="title">七、服务终止</div>
      <div class="content">1.用户终止
        <div class="content"> （1）用户如不愿再继续使用弈小象所提供的服务，应以书面方式通知弈小象申请退费，弈小象将就其已缴纳的费用扣除已经使用的部分后，退还剩余金额。已经使用部分的单价按照实际购买数量单价折算。实际购买值注册用户为购买服务所花费的实际支付，不包括弈小象提供的优惠、赠送等内容。</div>
        <div class="content"> （2）退款金额将按照用户的支付方式，退还给用户，对于有特殊情况的，退款将支付到由用户书面提供的本人银行账户。</div>
        <div class="content"> （3）用户明确理解并同意，如用户提前申请退费，或用户有重大违约事项被弈小象终止服务，则用户在购买课程时赠送的课程、优惠等项目不得折算为退款现金。</div>
        <div class="content"> （4）用户可向弈小象提出注销弈小象注册用户身份，经弈小象审核同意，由弈小象注销该注册用户，用户即解除与弈小象的用户协议关系。但注销该用户账号后，弈小象仍保留下列权利：</div>
        <div class="content">  A．用户注销后，弈小象有权保留该用户在弈小象网站相应的活动记录；</div>
        <div class="content">  B．用户注销后，如用户在注销前在弈小象上存在违法行为或违反合同的行为，弈小象仍可行使本用户协议所规定的权利。</div>
      </div>
      <div class="content">2.弈小象终止
        <div class="content"> 在下列情况下，弈小象可以随时终止服务：</div>
        <div class="content"> （1）在用户违反本用户协议以及其它相关规定时，弈小象有权终止向该用户提供服务并删除账号、密码等信息。在此情形下，用户若已购买课程服务，已缴纳的课程费用不予返还。弈小象将在终止服务时通知用户。但如该用户在被弈小象终止提供服务后，再一次直接或间接或以他人名义注册为弈小象用户的，弈小象有权再次单方面终止向该用户提供服务；</div>
        <div class="content"> （2）弈小象发现用户注册数据中内容是虚假或不存在的，弈小象有权随时终止向该用户提供服务；如弈小象有合理理由怀疑用户提供的资料错误、不实、过时或不完整的，弈小象有权发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对用户提供部分或全部服务。弈小象对此不承担任何责任，用户将承担因此产生的任何直接或间接损失及不利后果。</div>
        <div class="content"> （3）用户协议更新时，用户明示不愿接受新的用户协议的；</div>
        <div class="content"> （4）不可抗力导致本协议不能履行的，不可抗力”是指双方不可预见、或可以预见但不能避免并或克服的客观情况，该事件妨碍、影响或延误任何一方根据合同履行其全部或部分义务。该事件包括但不限于政府行为、自然灾害、战争、网络堵塞或中断、黑客袭击或任何其他类似事件；</div>
        <div class="content">  （5）其它弈小象认为需终止服务的情况。</div>
        <div class="content">在上述情况下，弈小象不就终止服务而对用户或任何第三者承担任何责任。终止服务后，用户没有权利要求弈小象，弈小象也没有义务传送任何未处理的信息或提供未完成的服务给用户或第三方。</div>
      </div>
      <div class="title">八、责任范围</div>
      <div class="content">1.用户明确理解和同意，弈小象不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿(无论弈小象是否已被告知该等损害赔偿的可能性)：
        <div class="content"> A.对于用户因帐户或密码泄露造成的各种损失；</div>
        <div class="content"> B.由于不可抗力或其他非因弈小象的原因使本站系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录或服务中断或停止等；</div>
        <div class="content"> C.弈小象依据本协议第7条第2款终止服务时；</div>
      </div>
      <div class="content"> 2.用户明确理解并同意，如因其违反有关法律或者本协议之规定，使弈小象遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对弈小象提供补偿，包括合理的律师费用等。</div>
      <div class="content"> 3.弈小象拒绝提供任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。弈小象不担保其服务一定能够满足用户的要求，也不担保其服务不会因各种客观原因中断，对服务的及时性、安全性、出错发生均不作担保，由用户自己承担系统受损或资料丢失的风险和责任。</div>
      <div class="content"> 4.用户理解并同意，因弈小象过错导致用户不能享受相应服务，弈小象承担相应责任的最高限为用户实际支付的全部费用。</div>
      <div class="title">九、隐私权制度</div>
      <div class="content">1.适用范围：
        <div class="content"> （1）用户注册弈小象账户时，用户根据弈小象要求提供的个人注册信息；</div>
        <div class="content"> （2）在用户使用弈小象服务，参加弈小象活动，或访问弈小象网页时，弈小象自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录；</div>
        <div class="content"> （3）弈小象收集到的用户在使用弈小象的有关数据，包括但不限于购买课程、预约课程、上课等行为；</div>
        <div class="content"> （4）弈小象通过合法途径从商业伙伴处取得的用户个人数据。</div>
      </div>
      <div class="content">2.信息使用：
        <div class="content"> （1）弈小象承诺不会向任何人出售、出租、出借或无偿提供用户的个人信息，除非事先得到用户的许可；</div>
        <div class="content"> （2）弈小象亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，弈小象有权立即终止与该用户的用户协议，查封其账号；</div>
        <div class="content"> （3）为服务用户的目的，弈小象可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与弈小象合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息（后者需要用户的事先同意）。</div>
      </div>
      <div class="content">3.信息披露：
        <div class="content">用户的个人信息将在下述情况下部分或全部被披露：</div>
        <div class="content"> （1）经用户书面同意，向第三方披露；</div>
        <div class="content"> （2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</div>
        <div class="content"> （3）为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；</div>
      </div>
      <div class="content">4.信息安全：
        <div class="content"> （1）弈小象账户有安全保护功能，请妥善保管用户的账户及密码信息；</div>
        <div class="content"> （2）如果用户发现自己的个人信息泄密，尤其是弈小象账户及密码发生泄露，请用户立即联络弈小象客服，以便弈小象采取相应措施。</div>
      </div>
      <div class="content">5.编辑和删除个人信息的权限：
        <div class="content"> 用户可以点击“会员中心”对用户的个人信息进行编辑和删除，除非弈小象另有规定；</div>
      </div>
      <div class="content">6.政策修改：
        <div class="content"> 弈小象保留对本隐私权制度作出不时修改的权利，隐私权政策构成本协议的有效组成部分。</div>
      </div>
      <div class="title">十、法律与管辖</div>
      <div class="content">1.本用户协议的订立、执行、解释和争议的解决均适用现行中华人民共和国法律法规。如发生本协议部分条款与中华人民共和国法律法规相抵触时，则这些条款将完全按法律法规的规定重新解释，本用户协议的其它条款仍对弈小象和用户具有法律约束力。本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，该规定可被删除而其余条款应予以执行。</div>
      <div class="content">2.如双方就本协议内容或其执行发生任何争议，双方应尽力通过友好协商解决；协商不成时，通过诉讼解决。诉讼由弈小象住所地及本用户协议签署地有管辖权的人民法院管辖。弈小象住所地及本用户协议签署地均为北京市朝阳区。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yhxy'
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .yhxy{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
  }
  .continer{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .docs-header{
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    position: relative;
    padding: 60px 0;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0,0,0,.1);
    background-color: #f2f9fe;
    border-bottom: 1px solid #e9f0f3;
  }
  .content{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 18px;
    line-height: 60px;
    letter-spacing: 5px;
  }
  .title{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    margin: 30px 0;
  }
  .content-1{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 16px;
    line-height: 60px;
    letter-spacing: 5px;
    text-indent: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/yhxy.vue